"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SmileyFaceSVG = void 0;
var _react = _interopRequireDefault(require("react"));
var _logging = require("../../../util/logging");
var _IconFaceHappy = _interopRequireWildcard(require("./IconFaceHappy"));
// eslint-disable-next-line zillow/import/no-named-default

var SmileyFaceSVG = _IconFaceHappy.FaceHappySVG;
exports.SmileyFaceSVG = SmileyFaceSVG;
var SmileyFace = function SmileyFace(props) {
  (0, _logging.logDeprecation)("`IconSmileyFace` has been deprecated, use `IconFaceHappy`");
  return /*#__PURE__*/_react.default.createElement(_IconFaceHappy.default, props);
};
SmileyFace.displayName = 'IconSmileyFace';
var _default = SmileyFace;
exports.default = _default;